import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { WorkspaceId } from '@/lib/workspaces';

interface WorkspaceState {
  /** Área escolhida por usuário (o navegador pode ser compartilhado). */
  byUser: Record<string, WorkspaceId>;
  setWorkspace: (userId: string, id: WorkspaceId) => void;
}

/** Área de trabalho do administrador, lembrada no navegador (`localStorage`). */
export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      byUser: {},
      setWorkspace: (userId, id) => set((s) => ({ byUser: { ...s.byUser, [userId]: id } })),
    }),
    {
      name: 'ld:workspace',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ byUser: s.byUser }),
    },
  ),
);
